// The tier a customer finding shows at, by its stored severity -- the platform's tiering
// (services/finding_status.tier_of: critical and error are Critical, warning is Warning,
// info and note are Info), with FYI for a finding whose check is informational
// (finding_status.is_informational). FYI findings are listed, never counted.
//
// Plain module, no imports, so tests can run it under node.

const SEVERITY_TIER = { critical: 'critical', error: 'critical', warning: 'warning', info: 'info', note: 'info' }

export function findingTier(obs) {
  if (obs?.observation_type === 'informational') return 'fyi'
  return SEVERITY_TIER[String(obs?.severity || 'info').trim().toLowerCase()] || 'info'
}

export const TIER_LABEL = { critical: 'Critical', warning: 'Warning', info: 'Info', fyi: 'FYI' }

// A finding whose last scan could not evaluate its check (finding_status NOT_EVALUATED):
// it is still open, but the latest run did not confirm it.
export const couldNotCheck = (obs) => obs?.last_check_outcome === 'not_evaluated'

// The counted total of the route's summary ({critical, warning, info}; FYI is not in it).
export const summaryTotal = (summary) =>
  summary ? (summary.critical || 0) + (summary.warning || 0) + (summary.info || 0) : 0

// The summary after one finding leaves the active list (a dismissal on this page).
export function summaryWithout(summary, obs) {
  if (!summary || !obs) return summary
  const tier = findingTier(obs)
  if (tier === 'fyi' || !(tier in summary)) return summary
  return { ...summary, [tier]: Math.max(0, (summary[tier] || 0) - 1) }
}
